import { getFeatureFlags } from "@/gen_src/proto/chalk/server/v1/flag-FeatureFlagService_connectquery";
import { getGraph } from "@/gen_src/proto/chalk/server/v1/graph-GraphService_connectquery";
import { DEFAULT_MAX_PERSISTED_QUERY_BYTES } from "@/utils/connect-query/query-cache-persistence/localforage-query-cache-client";
import { DescMethodUnary } from "@bufbuild/protobuf";

export interface PersistedGrpcQueryEndpoint {
  method: DescMethodUnary;
  maxBytes?: number;
}

// Read these endpoints through usePersistedGrpcQuery (or useGRPCQuery / useGetGraphQuery, which
// use it) so they wait for the cache restore instead of racing it with a network fetch.
export const PERSISTED_GRPC_QUERY_ENDPOINTS = [
  { method: getFeatureFlags, maxBytes: DEFAULT_MAX_PERSISTED_QUERY_BYTES },
  // Do not persist TeamService.GetTeam or TeamService.GetTeamPermissions.
  // Auto-impersonation relies on GetTeam as a fresh sentinel for the active impersonation cookie.
  { method: getGraph, maxBytes: DEFAULT_MAX_PERSISTED_QUERY_BYTES },
] satisfies PersistedGrpcQueryEndpoint[];

const PERSISTED_GRPC_QUERY_ENDPOINTS_BY_KEY = new Map(
  PERSISTED_GRPC_QUERY_ENDPOINTS.map((endpoint) => [
    getGrpcEndpointKey(endpoint.method.parent.typeName, endpoint.method.name),
    endpoint,
  ]),
);

export function getGrpcEndpointKey(serviceName: string, methodName: string): string {
  return `${serviceName}/${methodName}`;
}

export function getPersistedGrpcQueryEndpoint(
  serviceName: string,
  methodName: string | undefined,
): PersistedGrpcQueryEndpoint | null {
  if (methodName == null) {
    return null;
  }

  return (
    PERSISTED_GRPC_QUERY_ENDPOINTS_BY_KEY.get(getGrpcEndpointKey(serviceName, methodName)) ?? null
  );
}
